export default {
  panel: {
    comprehensiveStats: 'Comprehensive Information Statistics',
    jobDataStats: 'Job Data Statistics',
    deviceData: 'Device Data',
  },
  projectTab: {
    all: 'All',
    shenzhen: 'Shenzhen Project',
    shanghai: 'Shanghai Project',
    chengdu: 'Chengdu Project',
  },
  table: {
    deviceName: 'Device Name',
    deviceCount: 'Device Count',
    taskCount: 'Executed Task Count',
    alertCount: 'Alert Count',
  },
  deviceNames: {
    uav: 'UAV',
    robotDog: 'Robot Dog',
    robot: 'Robot',
  },
  deviceStatus: {
    online: 'Online',
    offline: 'Offline',
  },
  mapDeviceOffline: 'Device is offline; detail view is unavailable',
  // Devices clustered at the same location
  cluster: {
    panelTitle: 'Devices at this location',
    count: '{count} in total',
    empty: 'No devices',
  },
  mapMarkerStyle: {
    label: 'Map Icons',
    tech: 'Tech Minimal',
    business: 'Flat Business',
  },
  deviceTotalLabel: {
    airport: 'Airport',
    chargingPile: 'Charging Pile',
    total: 'Total',
  },
  jobDataLabel: {
    totalFlightDuration: 'Flight Duration (H)',
    totalRunDuration: 'Operation Duration (H)',
    totalMileage: 'Mileage (Km)',
    totalFlightTrips: 'Flight Sorties',
    totalDispatchCount: 'Dispatch Count',
  },
  loadingTip: 'Loading, please wait...',

  // Map center search
  centerSearch: {
    placeholder: 'Search a place or device, e.g. robot dog / dock',
    locate: 'Locate',
    emptyTip: 'Please enter a place or device name / SN',
    notReady: 'Map is not ready yet, please try again later',
    noResult: 'No place or device found for "{keyword}"',
    kindPlace: 'Place',
    kindDevice: 'Device',
    kindDock: 'Dock',
  },

  // Alarm Info Panel
  alarmInfo: {
    panel: {
      title: 'Alarm Information',
    },
    deviceTypes: {
      uav: 'UAV',
      robotDog: 'Robot Dog',
      robot: 'Robot',
    },
    table: {
      alarmType: 'Alarm Type',
      reportTime: 'Report Time',
      preview: 'Preview',
    },
    empty: {
      noData: 'No Data',
      noAlarmRecords: 'No alarm records under current filter',
    },
    loading: 'Loading...',
    noMoreData: 'No more data',
    loadMore: 'Pull down to load more',
  },

  // Device List Page
  deviceList: {
    refresh: {
      title: 'Refresh Device List',
      buttonText: 'Refresh',
      updatedAt: 'Updated at',
    },
    stats: {
      totalDevices: 'Total Devices',
      onlineDevices: 'Online Devices',
      offlineDevices: 'Offline Devices',
      clickFilterAll: 'Click to filter · All devices',
      percentage: 'Account for',
    },
    device: {
      unnamed: 'Unnamed Device',
      sn: 'Device SN',
      type: 'Device Type',
      battery: 'Battery',
      batteryAlarm: 'Low battery',
      selfCheck: 'Self-check',
      selfCheckNormal: 'Normal',
      selfCheckAbnormal: 'Abnormal',
    },
    empty: {
      noData: 'No Device Data',
      noOnline: 'No Online Devices',
      noOffline: 'No Offline Devices',
      retryLater: 'Please try again later',
    },
    category: {
      label: 'Category',
      all: 'All',
      piano: 'Piano Robot',
      dance: 'Dance Robot',
      tem: 'Transport Robot',
    },
    loading: 'Loading...',
  },

  // Task List Page
  taskList: {
    viewMode: {
      table: 'Table',
      card: 'Card',
    },
    filters: {
      taskNamePlaceholder: 'Task Name',
      deviceSNPlaceholder: 'Device SN',
      mapNamePlaceholder: 'Map Name',
      query: 'Search',
      reset: 'Reset',
    },
    actions: {
      createTask: 'Create Task',
      inspectionReport: 'Inspection Report',
      mediaRecord: 'Media Record',
      liveExecution: 'Live Execution',
      repeatExecution: 'Repeat Execution',
      delete: 'Delete',
    },
    table: {
      taskName: 'Task Name',
      deviceSN: 'Device SN',
      progress: 'Progress',
      map: 'Map',
      status: 'Status',
      createTime: 'Create Time',
      actions: 'Actions',
    },
    card: {
      unnamedTask: 'Unnamed Task',
      deviceSN: 'Device SN: ',
      map: 'Map: ',
      createTime: 'Create Time: ',
      progress: 'Progress: ',
    },
    status: {
      idle: 'Idle',
      running: 'Running',
      paused: 'Paused',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      mapSwitching: 'Map Switching',
      mapFailed: 'Map Failed',
      pendingRun: 'Pending Run',
      unknown: 'Unknown',
    },
    empty: {
      noData: 'No Task Data',
    },
    loading: 'Loading...',
    messages: {
      missingDeviceSN: 'The task lacks device SN and cannot open live view',
      cannotCopy: 'Cannot copy: Missing task ID',
      copySuccess: 'Copied and created new task',
      copyFailed: 'Copy failed',
      dogOfflineCannotExecute: 'The robot dog is offline and cannot execute the task',
      cannotDelete: 'Cannot delete: Missing task ID',
      deleteRestriction: 'Only completed or tasks that have not ended for more than 1 hour can be deleted',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
    },
    deleteConfirm: {
      title: 'Confirm Delete Task',
      content: 'After deletion, it cannot be recovered and related data will be cleared.',
      okText: 'Confirm Delete',
      cancelText: 'Cancel',
    },
  },

  // Create Task Modal
  createTask: {
    modal: {
      title: 'Create Task',
      okText: 'Confirm',
      cancelText: 'Cancel',
    },
    steps: {
      selectDevice: 'Select Device',
      selectMap: 'Select Map',
      confirmTask: 'Confirm Task',
      stepTip: 'Click on step bar to quickly switch',
    },
    device: {
      unnamed: 'Unnamed Device',
      online: 'Online',
      offline: 'Offline',
      empty: 'No Device',
      noOnlineDevice: 'No online device available',
      deviceOffline: 'This device is offline and cannot be selected',
      cannotExecute: 'This device cannot execute a task at the moment',
      selectDeviceFirst: 'Please select a device first',
    },
    map: {
      noDescription: 'No Description',
      noMapAvailable: 'No map available for this device',
      selectMapFirst: 'Please select a map first',
    },
    points: {
      selectPoints: 'Select Points',
      selectedCount: 'Select Points',
      noPointsAvailable: 'No points available for this map',
      selectAtLeastOne: 'Please select at least one point',
    },
    form: {
      taskName: 'Task Name',
      taskNamePlaceholder: 'Please enter task name',
      taskNameRequired: 'Please enter task name',
      taskNameLength: 'Task name length should be 2-50 characters',
    },
    messages: {
      submitInConfirmStep: 'Please enter "Confirm Task" step through step bar before submitting',
      enterConfirmStep: 'Please enter "Confirm Task" step through step bar before submitting',
      taskCreatedSuccess: 'Task created successfully',
      taskCreatedFailed: 'Task creation failed',
    },
    validation: {
      enterTaskName: 'Please enter task name',
      selectAtLeastOnePoint: 'Please select at least one point',
    },
  },
}
